import type { SovosUploadFile } from 'src/interfaces/SovosUploadFile';

export const getFormDataObject = (files: SovosUploadFile[]) => {
	const formData = new FormData();
	files.forEach((file) => {
		formData.append('file', file);
	});
	return formData;
};
